<template>
	<div class="min-h-0">
		<app-title-bar :icon="['fas', 'fa-desktop']" title="Hire Desk Workspace">
			<div class="flex flex-col sm:flex-row sm:items-center gap-2">
				<depots-dropdown v-if="depot" v-model="depot" size="large" update-user required />
				<app-button icon="fa-arrows-rotate" @click="refresh++"
					>Refresh</app-button
				>
			</div>
		</app-title-bar>

		<div>
			<div v-if="depot" class="w-full flex flex-col lg:flex-row gap-4 py-2">
				<hire-desk-panel
					:key="depot + Math.random()"
					:refresh-trigger="refresh"
					title="Stock Check"
					area="stock-check"
					:depot="depot"
					route="hire-desk-stock-item"
					view-all="/hire-desk/stock-items" />

				<hire-desk-panel
					:key="depot + Math.random()"
					:refresh-trigger="refresh"
					title="Pick / Load"
					area="pick"
					:depot="depot"
					route="hire-desk-pick-item"
					view-all="/hire-desk/pick-items" />

				<hire-desk-panel
					:key="depot + Math.random()"
					:refresh-trigger="refresh"
					title="Journey"
					area="journey"
					:depot="depot"
					route="hire-desk-journey-item"
					view-all="/hire-desk/journey-items" />
			</div>

			<div v-if="depot" class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 py-2">
				<hire-desk-panel
					:key="depot + Math.random()"
					:refresh-trigger="refresh"
					title="Collections"
					area="collections"
					:depot="depot"
					route="hire-desk-collection-item"
					view-all="/hire-desk/collection-items" />
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import DepotsDropdown from '@/components/partials/dropdowns/DepotsDropdown.vue'
	import HireDeskPanel from '@/components/partials/panels/HireDeskPanel.vue'
	import { ref, onMounted } from 'vue'
	import useAuthStore from '@/stores/auth'

	// Resources
	const auth = useAuthStore()

	// Data
	const depot = ref<string | null>(null)
	const refresh = ref(0)

	onMounted(() => {
		if (auth.user && auth.user.current_depot) {
			depot.value = auth.user.current_depot
		}
	})
</script>
